
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { contractOrderList, setDoupOrder, closeOrder, cancelOrder } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
type: 1,
holdList: [],
trade_type: "",
setWin:false,
profit_price: "", //止盈价格
winid: "", //止盈止损订单id
loss_price: "", //止损价格
}
},
computed:{
...mapState(['token'])
},
created(){
this.trade_type = this.$route.query.trade_type
this.SETTOKEN()
clearInterval(this.timerInfo)
this.timerInfo = null
this.getData(true)
this.timerInfo = setInterval(() => {
this.getData()
}, 2000);
},
methods:{
...mapMutations(['SETTOKEN']),
getData(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}
contractOrderList({token: this.token,status: this.type, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}

console.log("error")
})
},
clearTimer() { //清楚定时器

clearInterval(this.timerInfo)
this.timerInfo = null
},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
cancelOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
closeOrder(id){
var that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行平仓操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
closeOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getData(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
setWinId(id){
this.winid=id
this.setWin = true
},
addProfitPrice(){
this.profit_price = Number(this.profit_price+1)
},
addLossPrice(){
this.loss_price = Number(this.loss_price+1)
},
minusProfitPrice(){
if(this.profit_price==0){
return
}
this.profit_price = Number(this.profit_price-1)
},
minusLossPrice(){
if(this.loss_price==0){
return
}
this.loss_price = Number(this.loss_price-1)
},
setWinSave(){
if(this.profit_price==''){
this.sendMsg(this.$t("请输入止盈价格"))
return
}
if(this.loss_price==''){
this.sendMsg(this.$t("请输入止损价格"))
return
}
const that = this
that.$Loading()

setDoupOrder({token: that.token, id: this.winid, profit_price: that.profit_price, loss_price: this.loss_price,trade_type: this.trade_type,}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getData(true)

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
goContract(type, name, code){
this.$router.push(`/pages/info?name=${name}&type=${type}&trade_type=3&code=${name}&nation=${this.$route.query.nation}&enter=hold`)

},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/holdPosition.vue